import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";
import SidebarMenu from '../components/SidebarMenu';
//import 'react-toastify/dist/ReactToastify.css';


const Niveles = () => {
  const [niveles, setNiveles] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [editandoNivelId, setEditandoNivelId] = useState(null);
  const [nuevaDescripcion, setNuevaDescripcion] = useState("");
  const navigate = useNavigate();

  //  Obtener niveles al cargar la página
  useEffect(() => {
    fetchNiveles();
  }, []);


  const fetchNiveles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Lider/ListarNiveles`);
      setNiveles(response.data);
    } catch (error) {
      console.error("❌ Error al obtener niveles:", error);
    }
  };

  //  Crear un nuevo nivel
  const handleCrearNivel = async () => {
    if (!descripcion.trim()) {
      setMensaje("⚠️ Ingresa una descripción válida.");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/Lider/CrearNivel`, { descripcion });
      toast.success("Nivel creado correctamente.", {
        position: "top-right",
        autoClose: 3000, // Se cierra en 3 segundos
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#081b29", // Azul
          color: "#FFFFFF", // Texto blanco
          fontWeight: "bold",
          borderRadius: "8px",
        },
      });
    } catch (error) {
      console.error("❌ Error al crear nivel:", error);
      setMensaje("⚠️ Error al crear nivel.");
    }
  };

  //  Función para habilitar la edición del nivel
  const habilitarEdicion = (nivelId, descripcionActual) => {
    setEditandoNivelId(nivelId);
    setNuevaDescripcion(descripcionActual);
  };

  //  Guardar la nueva descripción del nivel
  const actualizarNivel = async (nivelId, nuevaDescripcion, setEditandoNivelId, fetchNiveles) => {
    if (!nuevaDescripcion || !nuevaDescripcion.trim().length === 0) { // Updated check here
      toast.warn(" Ingresa una descripción válida.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: { backgroundColor: "#ffa726", color: "#ffffff", borderRadius: "8px" },
      });
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/Lider/ActualizarNivel`, null, {
        params: { nivelId, nuevaDescripcion },
      });

      toast.success(" Nivel actualizado correctamente.", {
        position: "top-right",
        autoClose: 3000, // Se cierra en 3 segundos
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#081b29", // Azul
          color: "#FFFFFF", // Texto blanco
          fontWeight: "bold",
          borderRadius: "8px",
        },
      });
      setEditandoNivelId(null);
      fetchNiveles();
    } catch (error) {
      console.error("❌ Error al actualizar nivel:", error);
      toast.error("⚠️ Hubo un error al actualizar el nivel.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: { backgroundColor: "#d32f2f", color: "#ffffff", borderRadius: "8px" },
      });
    }
  };


  return (
    <div className="wrapper p-6 flex flex-col items-center space-y-6">
      {/*  MONYTOR */}
      <SidebarMenu />
      <ToastContainer />
      <img
        src="/img/monytorlogoa.png"
        alt="Imagen de login"
        className="login-image"
      />

      {/*  Título */}
      <h2 className="text-white text-3xl font-bold">Gestor de Niveles</h2>

      {/*  Mensaje de estado */}
      {mensaje && <p className="text-yellow-400">{mensaje}</p>}

      {/*  Contenedor de botones */}
      <div className="flex space-x-4">
        {!mostrarFormulario ? (
          <button
            onClick={() => setMostrarFormulario(true)}
            className="btn text-white px-4 py-2 rounded-md  transition flex items-center"
          >
             Crear Nivel
          </button>
        ) : (
          <div className="flex items-center space-x-2">
            <input
              type="text"
              className="p-2 border rounded-md bg-gray-800 text-white placeholder-gray-400"
              placeholder="Nombre del nivel..."
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
            <button
              onClick={handleCrearNivel}
              className="btn text-white px-4 py-2 rounded-md transition"
            >
               Guardar
            </button>
            <button
              onClick={() => setMostrarFormulario(false)}
              className="btn text-white px-4 py-2 rounded-md  transition"
            >
              Cancelar
            </button>
          </div>
        )}

        {/*  Botón de regreso */}
        <button
          className="btn text-white px-4 py-2 rounded-md  transition"
          onClick={() => navigate("/admin/menu")}
        >
            Menú
        </button>
      </div>

      {/*  Tabla de Niveles con opción para cambiar descripción */}
      <div className="w-full max-w-3xl overflow-x-auto">
        <h3 className="text-white text-xl mb-3">Listado de Niveles</h3>
        <table className="w-full bg-[#081b29] border border-gray-700 text-white rounded-lg">
          <thead>
            <tr className="bg-[#0f283a] text-white">
              <th className="px-4 py-2 border border-gray-700">ID</th>
              <th className="px-4 py-2 border border-gray-700">Descripción</th>
              <th className="px-4 py-2 border border-gray-700">Acción</th>
            </tr>
          </thead>
          <tbody>
            {niveles.length > 0 ? (
              niveles.map((nivel) => (
                <tr key={nivel.id} className="text-center border border-gray-700 hover:bg-[#12394d] transition">
                  <td className="px-4 py-2 border border-gray-700">{nivel.id}</td>
                  <td className="px-4 py-2 border border-gray-700">
                    {editandoNivelId === nivel.id ? (
                      <input
                        type="text"
                        className="p-2 bg-gray-800 text-white border rounded w-full"
                        value={nuevaDescripcion}
                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                      />
                    ) : (
                      nivel.descripcion
                    )}
                  </td>
                  <td className="px-4 py-2 border border-gray-700">
                    {editandoNivelId === nivel.id ? (
                      <div className="flex space-x-2">
                        <button
                          className="btn text-white px-3 py-1 rounded transition"
                          onClick={() => actualizarNivel(nivel.id, nuevaDescripcion, setEditandoNivelId, fetchNiveles)}
                        >
                           Guardar
                        </button>
                        <button
                          className="btn text-white px-3 py-1 rounded  transition"
                          onClick={() => setEditandoNivelId(null)}
                        >
                           Cancelar
                        </button>
                      </div>
                    ) : (
                      <button
                        className="btn text-white px-3 py-1 rounded transition"
                        onClick={() => habilitarEdicion(nivel.id, nivel.descripcion)}
                      >
                         Editar
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4 text-gray-400">
                  No hay niveles registrados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Niveles;
